import axios from "axios";
import { API_ENDPOINTS } from "./endpoints";

function useApiClient() {
  const accessToken = JSON.parse(localStorage.getItem('user') || '{}').access_token;

  // User Service
  async function signIn(email: string, password: string) {
    const backendEnv = localStorage.getItem('backend_env') as keyof typeof API_ENDPOINTS;
    const response = await axios.post(
      API_ENDPOINTS[backendEnv].USER_SERVICE + '/api/user/sign-in',
      {
        email,
        password,
      }
    );

    return response.data;
  }

  async function getProfileRole(accessToken: string) {
    const backendEnv = localStorage.getItem('backend_env') as keyof typeof API_ENDPOINTS;
    const response = await axios.get(
      API_ENDPOINTS[backendEnv].USER_SERVICE + '/api/user/profile-with-role',
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  }

  async function enableDisableUser(email: string, account: string) {
    const backendEnv = localStorage.getItem('backend_env') as keyof typeof API_ENDPOINTS;
    const response = await axios.post(
      API_ENDPOINTS[backendEnv].USER_SERVICE + '/api/user/enabled-disabled',
      {
        email,
        account,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  }

  async function getUserAnalyticsData(startDate: string, endDate?: string) {
    const backendEnv = localStorage.getItem('backend_env') as keyof typeof API_ENDPOINTS;
    let url = API_ENDPOINTS[backendEnv].USER_SERVICE + `/api/user/analytics?start_date=${startDate}`;
    if (endDate) {
      url += `&end_date=${endDate}`;
    }

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  }

  // Hostel Service
  async function getBlogById(id: string, env?: string) {
    let endpoint: string;
    if (env) {
      endpoint = API_ENDPOINTS[env as keyof typeof API_ENDPOINTS].HOSTEL_SERVICE + `/api/blogs/${id}`;
    } else {
      const backendEnv = localStorage.getItem('backend_env') as keyof typeof API_ENDPOINTS;
      endpoint = API_ENDPOINTS[backendEnv].HOSTEL_SERVICE + `/api/blogs/${id}`;
    }

    const response = await axios.get(
      endpoint,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  }

  async function createBlog(data: any) {
    const backendEnv = localStorage.getItem('backend_env') as keyof typeof API_ENDPOINTS;
    const response = await axios.post(
      API_ENDPOINTS[backendEnv].HOSTEL_SERVICE + '/api/blogs',
      data,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  }

  async function deleteBlog(id: string) {
    const backendEnv = localStorage.getItem('backend_env') as keyof typeof API_ENDPOINTS;
    const response = await axios.delete(
      API_ENDPOINTS[backendEnv].HOSTEL_SERVICE + `/api/blogs/${id}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  }

  async function getBlogCategories(env?: string) {
    let backendEnv = localStorage.getItem('backend_env') as keyof typeof API_ENDPOINTS;
    if (env) {
      backendEnv = env as keyof typeof API_ENDPOINTS;
    }

    const response = await axios.get(
      API_ENDPOINTS[backendEnv].HOSTEL_SERVICE + '/api/blog-categories',
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  }

  // Trip Service
  async function updateTripInfo(data: any) {
    const backendEnv = localStorage.getItem('backend_env') as keyof typeof API_ENDPOINTS;
    const response = await axios.patch(
      API_ENDPOINTS[backendEnv].TRIP_SERVICE + '/admin/trip-info',
      data,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  }

  // Post Service
  async function deletePost(id: string) {
    const backendEnv = localStorage.getItem('backend_env') as keyof typeof API_ENDPOINTS;
    const response = await axios.delete(
      API_ENDPOINTS[backendEnv].POST_SERVICE + `/api/post/admin/post/${id}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  }

  async function togglePostVisibility(id: string) {
    const backendEnv = localStorage.getItem('backend_env') as keyof typeof API_ENDPOINTS;
    const response = await axios.post(
      API_ENDPOINTS[backendEnv].POST_SERVICE + `/api/post/admin/toggle-post-visibility/${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  }

  async function getPostAnalyticsData(startDate: string, endDate?: string) {
    const backendEnv = localStorage.getItem('backend_env') as keyof typeof API_ENDPOINTS;
    let url = API_ENDPOINTS[backendEnv].POST_SERVICE + `/api/post/analytics?start_date=${startDate}`;
    if (endDate) {
      url += `&end_date=${endDate}`;
    }

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  }


  
  async function getPlanAnalyticsData(startDate: string, endDate?: string) {
    const backendEnv = localStorage.getItem('backend_env') as keyof typeof API_ENDPOINTS;
    let url = API_ENDPOINTS[backendEnv].PLAN_SERVICE + `/api/plan/analytics?start_date=${startDate}`;
    if (endDate) {
      url += `&end_date=${endDate}`;
    }

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  }


  
  async function getChatAnalyticsData(startDate: string, endDate?: string) {
    const backendEnv = localStorage.getItem('backend_env') as keyof typeof API_ENDPOINTS;
    let url = API_ENDPOINTS[backendEnv].CHAT_SERVICE + `/api/conversation/analytics?start_date=${startDate}`;
    if (endDate) {
      url += `&end_date=${endDate}`;
    }

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  }

  // Hangout Service
  async function getHangoutAnalyticsData(startDate: string, endDate?: string) {
    const backendEnv = localStorage.getItem('backend_env') as keyof typeof API_ENDPOINTS;
    let url = API_ENDPOINTS[backendEnv].HANGOUT_SERVICE + `/api/hangouts/analytics?start_date=${startDate}`;
    if (endDate) {
      url += `&end_date=${endDate}`;
    }

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  }

  async function getReferralAnalyticsData(startDate: string, endDate?: string) {
    const backendEnv = localStorage.getItem('backend_env') as keyof typeof API_ENDPOINTS;
    let url = API_ENDPOINTS[backendEnv].MATCHING_PROFILE_SERVICE + `/api/analytics?start_date=${startDate}`;
    if (endDate) {
      url += `&end_date=${endDate}`;
    }

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  }

  return {
    // User Service
    signIn,
    getProfileRole,
    enableDisableUser,
    getUserAnalyticsData,

    // Hostel Service
    getBlogById,
    createBlog,
    deleteBlog,
    getBlogCategories,

    // Trip Service
    updateTripInfo,

    // Post Service
    deletePost,
    togglePostVisibility,
    getPostAnalyticsData,

    // Hangout Service
    getHangoutAnalyticsData,

    // Plan service
    getPlanAnalyticsData,

    // Chat service
    getChatAnalyticsData,

    // Referral analytics
    getReferralAnalyticsData
  };
}

export default useApiClient;
